import { EntityType } from '../dictionaries/EntityType';

export class ImageInfo {
    Id: number;
    EntityType: EntityType;
    ProductId: number;
    ImagePath: string;
    Image: File;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/image-info.ts